<template>
  <div>
    <div class="live-container">
      <div class="container">
        <div class="video-wrap">
          <video-player
            :width="1200"
            :height="675"
            :loading="!isLoaded"
            :view-id="loginUser.userId || 0"
          ></video-player>
        </div>
      </div>
    </div>
    <div class="bg-white-wrapper">
      <ul class="live-detail-tabs-nav">
        <li class="active">回放介绍</li>
        <li ref="tabNavLine" class="highlight"></li>
      </ul>
      <div class="container live-details" v-html="intro"></div>
    </div>
  </div>
</template>
<script>
import AppHeader from '../../components/common/AppHeader';
import AppFooter from '../../components/common/AppFooter';
import VideoPlayer from '../../components/common/VideoPlayer';
import { siteMixin } from '../../utils/mixin';
import { study, account } from '../../request';
export default {
  mixins: [siteMixin],
  data() {
    return {
      isLoaded: false,
      intro: '',
    };
  },
  async mounted() {
    this.setMetaData('直播回放');

    await this.getLiveType();
    let liveLogin = true;
    if (this.loginType == 3) {
      liveLogin = false;
    }

    if (this.siteConfig.agencyId != 0 && !this.isLogin && liveLogin) {
      this.$router.push({
        name: 'LoginLive',
        query: { redirect: this.$route.fullPath },
      });
      return;
    }

    this.getData();
  },
  methods: {
    async getLiveType() {
      const liveId = this.$route.params.id;
      if (!liveId) return;
      const result = await account.getLiveLoginType(liveId);
      if (result.status === 1) {
        this.loginType = result.data;
      }
      return result;
    },
    getData() {
      const liveId = this.$route.params.id;
      if (!liveId) return;
      study
        .getLiveInfo(liveId, this.isLogin ? this.loginUser.userId : 0)
        .then((res) => {
          //console.log("liveInfo", res);
          this.isLoaded = true;
          if (res.status === 1) {
            this.intro = res.data.Introduce;
            this.setIsBuy(true);
            this.setVideoId(res.data.ReplayId);
          }
        });
    },
  },
  components: {
    AppHeader,
    AppFooter,
    VideoPlayer,
  },
};
</script>
<style lang="less" scoped>
@import '../../assets/css/var.less';
@import '../../assets/css/exercise.less';
.live-container {
  background-color: #2f3133;
  padding: 20px 0;
}
.video-wrap {
  width: 100%;
  height: 675px;
}
.live-detail-tabs-nav {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  background: #fff;
  height: 55px;
  border-bottom: 2px solid #0195d3;
  li {
    position: relative;
    float: left;
    width: 150px;
    padding: 15px 25px;
    text-align: center;
    cursor: pointer;
    z-index: 1;
    transition: all 0.2s ease;
    &:hover,
    &.active {
      color: #ff7d2b;
    }
    &.highlight {
      position: absolute;
      left: 0;
      top: 0;
      width: 150px;
      height: 57px;
      border-bottom: 6px solid #ff7d2b;
      background-color: #fff;
      z-index: 0;
      transition: all 0.2s ease;
    }
  }
}
.live-details {
  padding: 20px 0;
  min-height: 300px;
}
</style>
